import React from 'react';

export const newRow={
businessArea:'',
courseCategory:'',
term: '',
academicGroup:'',
academicCareer:'',
concessionPercentage:'',
amount: ""
}
export const initialForm={
businessAreas:[],
courseCategories:[],
terms: [],
academicGroups:[],
academicCareers:[], 
}
export const getFilterFormFields = dropdownData => {
    const { businessArea, courseCategory, term, academicGroup,academicCareer} = dropdownData ||{};

    return [
        {
            label: 'Business Area',
            type: 'select',
            items: businessArea,
            formKey: 'businessAreas',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Business Area",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Course Category',
            type: 'select',
            items: courseCategory,
            formKey: 'courseCategories',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Course Category",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Term',
            type: 'select',
            items: term,
            formKey: 'terms',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Term",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Academic Group',
            type: 'select',
            items: academicGroup,
            formKey: 'academicGroups',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Academic Group",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Carrier',
            type: 'select',
            items: academicCareer,
            formKey: 'academicCareers',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Carrier",
            disbabled: false,
            isShowCount: true
        },
    ]
}

export const isValidReqObj=(reqObj)=> {
  return Object.values(reqObj).every(
    (value) => value !== null && value !== undefined && value !== ''
  );
}

export const statusStyle = {
  SUCCESS: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  PROCESSING: {
    backgroundColor: "#FFEDC8",
    color: "#705010",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  FAILED: {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },

};

export const statusMapping = {
  SUCCESS: "Success",
  PROCESSING: "In Progress",
  FAILED: "Failed",
};

export const getStatusDescription=(type,response)=>{
   switch(type){
    case "SUCCESS": return <span style={{color: "#0B442D"}}>Upload completed successfully</span>
    case "PROCESSING": return <span style={{color: "#705010"}}>Upload completed successfully</span>
    case "FAILED" : return <span style={{color: "#B32306"}}>{response}</span> 
   } 
}

export const CONFIG_TYPE="?type=arpuMasterConfig"

export const TEMPLATE_NAME='BULK_UPLOAD_FOR_ARPU';

export const BULK_TYPE= "arpuBulkUpload";
